import { IPromoStatusRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetPromoStatusUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IPromoStatusRepositoryResponse> {
    return this.lookupRepository.getPromoStatuses();
  }
}
